export const getTotalProgramPrice = (rooms) => {
  return rooms.reduce((total, room) => {
    const roomTotal = room.people.reduce((peopleTotal, person) => {
      return peopleTotal + (Number(person.program_price) || 0);
    }, 0);
    return total + roomTotal;
  }, 0);
};

export const guestHasDiscount = (person) => {
  const price = Number(person.program_price) || 0;
  const discountSum = Number(person.program_discount_sum) || 0;
  return discountSum > 0 && discountSum < price;
};

export const guestHasVisibleDiscount = (person) =>
  guestHasDiscount(person) && Number(person.program_discount_hide) === 0;

export const guestHasHiddenDiscount = (person) =>
  guestHasDiscount(person) && Number(person.program_discount_hide) === 1;

export const getGuestDisplayPrice = (person) => {
  if (guestHasDiscount(person)) {
    return Number(person.program_discount_sum) || 0;
  }

  return Number(person.program_price) || 0;
};

export const getTotalDisplayPrice = (rooms) => {
  return rooms.reduce((total, room) => {
    const roomTotal = room.people.reduce((peopleTotal, person) => {
      return peopleTotal + getGuestDisplayPrice(person);
    }, 0);
    return total + roomTotal;
  }, 0);
};

export const hasVisibleBookingDiscount = (rooms) =>
  rooms.some((room) => room.people.some(guestHasVisibleDiscount));

export const getBookingDiscountText = (rooms) =>
  rooms
    .flatMap((room) => room.people)
    .filter(guestHasVisibleDiscount)
    .map((person) => person.program_discount_text?.trim())
    .find(Boolean) || '';
